module.exports = __webpack_public_path__ + "img/animated-tele-sticker.6d979cad.svg";